import { AxiosError } from 'axios';
import { getApiClient } from './api.base';
import { FundraisingDetailResponse } from '@/models/fundraising-detail-response.model';

type Response = FundraisingDetailResponse & AxiosError;

export const fundraisingDetail = async (id: string): Promise<Response> => {
  try {
    const response = await getApiClient('search').get(
      `/api/v1/fundraising/detail/${id}`
    );
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    return error;
  }
};
